// @flow

import * as React from "react";
import { useSelector } from "react-redux";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Icon from "../atoms/Icon";
import Image from "../atoms/Image";
import YoutubeVideo from "./YoutubeVideo";

type PropsType = {
    media: any[],
    initialSlide: number,
};

const ArrowGroup = ({
    next,
    previous,
    goToSlide,
    media,
    ...rest
}: any): React.Node => {
    const {
        carouselState: { currentSlide, totalItems },
    } = rest;

    return (
        <div className="media-carousel__footer">
            <div className="media-carousel__footer__top-content">
                <div className="media-carousel__slide-count">
                    {currentSlide + 1} / {totalItems}
                </div>
                {totalItems > 1 ? (
                    <div className="arrow-button-group">
                        <button
                            className={`arrow-button-group__left`}
                            onClick={(): void => previous()}
                        >
                            <Icon name="stem-arrow-left" />
                        </button>
                        <button
                            className={`arrow-button-group__right`}
                            onClick={(): void => next()}
                        >
                            <Icon name="stem-arrow-right" />
                        </button>
                    </div>
                ) : null}
            </div>

            <div className="media-carousel__footer__bottom-content">
                {media[currentSlide] ? (
                    <div className="media-carousel__caption">
                        {media[currentSlide].caption}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

const MediaCarousel = (props: PropsType): React.Node => {
    let refCarousel: any = React.useRef();
    const { default_tile_image } = useSelector(
        (state: any): any => state.options
    );

    const responsive = {
        default: {
            breakpoint: { max: 9999, min: 0 },
            items: 1,
        },
    };

    React.useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if (refCarousel) {
            refCarousel.goToSlide(props.initialSlide, true);
        }
    }, [props.initialSlide]);

    return (
        <div className="media-carousel">
            {props.media ? (
                <Carousel
                    ref={el => (refCarousel = el)}
                    arrows={false}
                    responsive={responsive}
                    customButtonGroup={<ArrowGroup media={props.media} />}
                    itemClass="media-carousel__item"
                    renderButtonGroupOutside={true}
                >
                    {props.media.map((item, index) => {
                        const imageSrc =
                            item.src ||
                            (item.image
                                ? item.image.url
                                : default_tile_image.sizes.medium_large);
                        return (
                            <div key={index}>
                                {item.youtube_url ? (
                                    <YoutubeVideo
                                        thumbnail={item.image}
                                        video_url={item.youtube_url.url}
                                        caption={item.caption}
                                    />
                                ) : (
                                    <Image
                                        src={imageSrc}
                                        alt={
                                            item.caption
                                                ? item.caption
                                                : item.image && item.image.alt
                                                ? item.image.alt
                                                : `Carousel preview image ${
                                                      index + 1
                                                  }`
                                        }
                                        aspectRatio="3:2"
                                    />
                                )}
                            </div>
                        );
                    })}
                </Carousel>
            ) : null}
        </div>
    );
};

export default MediaCarousel;
